import { createContext, useContext, useRef } from 'react'
import { useStore } from 'zustand'

import {
  createDemandAnalysisStore,
  DemandAnalysisStore,
  DemandAnalysisStoreData,
} from './demand-analysis-store'

const StoreContext = createContext<DemandAnalysisStore | null>(null)

interface DemandAnalysisStoreProviderProps {
  children: React.ReactNode
}

export function DemandAnalysisStoreProvider({
  children,
}: DemandAnalysisStoreProviderProps) {
  const storeRef = useRef<DemandAnalysisStore | null>(null)

  if (!storeRef.current) {
    storeRef.current = createDemandAnalysisStore()
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  )
}

export function useDemandAnalysisStore<T = DemandAnalysisStoreData>(
  selector?: (state: DemandAnalysisStoreData) => T,
) {
  const store = useContext(StoreContext)

  if (!store) {
    throw new Error('Missing DemandAnalysisStoreProvider')
  }

  return useStore(store, (state: DemandAnalysisStoreData) =>
    selector ? selector(state) : (state as T),
  )
}
